/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PWMFrequencyDefinition } from './PWMFrequencyDefinition';
/**
 * Wrapper for inverter IGBT model to handle units and default values.
 */
export type InverterIGBTData = {
    modulation_index?: number;
    dc_harness_resistance?: number;
    ac_harness_resistance?: number;
    switching_energy_on?: number;
    switching_energy_off?: number;
    switching_energy_reverse?: number;
    voltage_ref?: number;
    current_ref?: number;
    pwm_frequency?: number;
    pwm_ratio?: number;
    pwm_definition?: PWMFrequencyDefinition;
    diode_voltage_drop?: number;
    diode_dynamic_resistance?: number;
    transistor_voltage_drop?: number;
    transistor_dynamic_resistance?: number;
    inverter_type?: InverterIGBTData.inverter_type;
};
export namespace InverterIGBTData {
    export enum inverter_type {
        IGBT = 'IGBT',
    }
}

